import React, { useEffect } from 'react'
import {
  Box,
  Button,
  DialogActions,
  DialogContentText,
  FormControl,
  RadioGroup,
  Typography,
} from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import DialogContent from './DialogContent'
import RadioCardOption from './RadioCardOption'
import { getProgramUsageTypeDescription, PROGRAM_DIALOG_HEIGHT } from './programUtils'

const StepProgramUsageType = ({
  programUsageTypes,
  loading,
  values,
  setFieldValue,
  handleSubmitStep,
}) => {
  useEffect(() => {
    setFieldValue('usageType', '')
  }, [setFieldValue])

  return (
    <>
      <DialogContent height={PROGRAM_DIALOG_HEIGHT}>
        <DialogContentText>
          You will only be charged for the funds used by your team members within the selected time
          period. Funds do not roll over to the next period.
        </DialogContentText>
        {loading && <SkeletonLoading />}

        {!loading && (
          <FormControl name="usageType" component="fieldset">
            <RadioGroup
              aria-label="subsidy cadence"
              name="usageType"
              value={values.usageType}
              onChange={e => {
                setFieldValue('usageType', e.target.value)
                handleSubmitStep()
              }}
            >
              {programUsageTypes.map(usageType => (
                <RadioCardOption
                  key={usageType.value}
                  value={usageType.value}
                  checked={values.usageType === usageType.value}
                >
                  <Typography variant="h6">{usageType.label}</Typography>
                  <Typography variant="body1">
                    {getProgramUsageTypeDescription(usageType.value)}
                  </Typography>
                </RadioCardOption>
              ))}
            </RadioGroup>
          </FormControl>
        )}
      </DialogContent>
      {/* Need this to maintain the dialog height */}
      <DialogActions>
        <Box visibility="hidden">
          <Button>Next</Button>
        </Box>
      </DialogActions>
    </>
  )
}

const SkeletonLoading = () => {
  return (
    <>
      <Skeleton height={125} />
      <Skeleton height={125} />
      <Skeleton height={125} />
    </>
  )
}

export default StepProgramUsageType
